import { Box, CircularProgress } from '@mui/material';
import React from 'react';

function PageLoader() {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      position='fixed'
      width='100%'
      height='100%'
      left={0}
      top={0}
      bgcolor='background.default'
    >
      <CircularProgress color='secondary' />
    </Box>
  );
}

export default PageLoader;
